/**
 * Resolve which site id to use for the Dashboard weather panel.
 * Local UI selection only — not a global "current site".
 *
 * @param {Array<{id?: string, siteId?: string, name?: string}>} sites
 * @param {string|null|undefined} preferredSiteId - e.g. userClaims.siteId when present in the list
 * @returns {{ siteId: string|null, siteName: string|null, sites: Array<{id: string, name: string}> }}
 */
export function resolveDashboardWeatherSites(sites, preferredSiteId) {
  const normalized = (Array.isArray(sites) ? sites : [])
    .map((site) => {
      const id = String(site?.id || site?.siteId || '').trim();
      if (!id) return null;
      return {
        id,
        name: String(site?.name || id).trim() || id,
      };
    })
    .filter(Boolean);

  if (normalized.length === 0) {
    return { siteId: null, siteName: null, sites: [] };
  }

  const preferred = String(preferredSiteId || '').trim();
  if (preferred && normalized.some((s) => s.id === preferred)) {
    const match = normalized.find((s) => s.id === preferred);
    return { siteId: match.id, siteName: match.name, sites: normalized };
  }

  return {
    siteId: normalized[0].id,
    siteName: normalized[0].name,
    sites: normalized,
  };
}
